import * as types from './types'

export default {
  [types.MUTATE_NEW_FRANCHISE_MANUAL_SIDEBAR]: (state, payload) => {
    state.newFranchiseManualSidebar = { ...state.newFranchiseManualSidebar, ...payload }
  },
  [types.MUTATE_PUBLISH_MANUAL_VERSION_SIDEBAR]: (state, payload) => {
    state.publishManualVersionSidebar = { ...state.publishManualVersionSidebar, ...payload }
  },
  [types.MUTATE_FRANCHISE_MANUALS_SEARCH_RESULT]: (state, payload) => {
    state.franchiseManualsSearchResult = payload
  },
  [types.MUTATE_MY_FRANCHISE_MANUAL_CYCLE]: (state, payload) => {
    state.myFranchiseManualCycle = payload
  },
  [types.MUTATE_MY_OPTIONAL_FRANCHISE_MANUAL_CYCLE]: (state, payload) => {
    state.myOptionalFranchiseManualCycle = payload
  },
}
